import { ready } from './lib/utils';

import { aggregate } from './modules/aggregate';
import { cards } from './modules/cards';
import { accordions } from './modules/accordions';

const results = {

	elem: {

	},

	init() {
		aggregate.init();
		cards.init();
		accordions.init();

		this.bindUIActions();
	},

	bindUIActions() {

	}

};

ready(function () {
	results.init();
});